<template>
  <li class="k-sidebar__item">
    <component
      :is="tag"
      class="k-sidebar__link"
      :class="{ 'k-sidebar__link--active': isActive }"
      v-bind="$attrs"
      @click.native="hideSidebar"
    >
      <slot>
        <span class="k-sidebar__link-icon">
          <i v-if="icon && !useShieldIcon && !useEuroIcon" :class="icon"></i>
          <svg
            v-if="useShieldIcon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <svg
            v-if="useEuroIcon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#84A98C"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M17 5.5a6 6 0 0 0-9.5 2.1A6 6 0 0 0 7 16.5a6 6 0 0 0 9 0" />
            <path d="M7 10h7" />
            <path d="M7 14h6.5" />
          </svg>
        </span>
        <span class="k-sidebar__link-text">{{ name }}</span>
      </slot>
    </component>
  </li>
</template>

<script>
/**
 * SidebarLink - Navigation link for sidebar
 * @description Individual navigation item with icon and label
 * @prop {String} name - Link display name
 * @prop {String} icon - Icon class name
 * @prop {Boolean} useShieldIcon - If true, renders shield SVG icon instead of icon class
 * @prop {Boolean} useEuroIcon - If true, renders euro SVG icon instead of icon class
 * @prop {String} tag - HTML/component tag to use
 */
export default {
  name: "SidebarLink",
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true,
    },
    addLink: {
      default: () => {},
    },
    removeLink: {
      default: () => {},
    },
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    useShieldIcon: {
      type: Boolean,
      default: false,
    },
    useEuroIcon: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: "router-link",
    },
  },
  computed: {
    /**
     * Checks if this link is currently active
     * @returns {Boolean}
     */
    isActive() {
      return this.$el && this.$el.classList.contains("router-link-active");
    },
  },
  methods: {
    /**
     * Hides sidebar on mobile after click
     */
    hideSidebar() {
      if (this.autoClose && this.$sidebar && window.innerWidth <= 991) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
